import { Common } from '@factorin/domain';
import { put } from 'redux-saga/effects';

import { useSelector } from 'Modules/core/redux';

import { environmentActions } from './actions';


const ENVIRONMENT_KEY = 'environment';

export const useEnvironment = <TType = any, TReturn = Common.Catalog<TType>>(
    path: string,
): TReturn => {
    const result = useSelector<TReturn>(`${ENVIRONMENT_KEY}.${path}`, [path]);
    return result;
};

export const useBusy = (path: string): boolean =>
    useSelector(`${ENVIRONMENT_KEY}.${path}.busy`, [path]);

export const withBusyWrapper = path => next =>
    function* busyWrapper() {
        yield put(environmentActions.setBusy(path)(true));
        yield next();
        yield put(environmentActions.setBusy(path)(false));
    };
